import Vue from 'vue'
import Router from 'vue-router'
import Layout from "@/pages/layout";
import Home from "@/pages/home";
import firstClass from "@/pages/firstClass";
import secondClass from "@/pages/secondClass";
import thirdClass from "@/pages/thirdClass";
import Article from "@/pages/article";

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'layout',
      component: Layout,
      children: [
        // {
        //   path: '/home',
        //   name: '首页',
        //   key: '1-1',
        //   component: Home,
        // },
        {
          path: 'menu/first/:firstActiveIndex/:firstId',
          name: '一级导航',
          key: '1-1',
          component: firstClass,
        },
        {
          path: 'class/first/:firstActiveIndex/:firstId/second/:secondActiveIndex/:secondId',
          name: '二级导航',
          key: '1-2',
          component: secondClass,
        },
        {
          path: 'navigation/first/:firstActiveIndex/:firstId/second/:secondActiveIndex/:secondId/third/:thirdActiveIndex/:thirdId',
          name: '三级导航',
          key: '1-3',
          component: thirdClass,
        },
        // {
        //   path: '/first/:firstActiveIndex/:firstId/second/:secondActiveIndex/:secondId',
        //   name: '二级导航',
        //   key: '1-2',
        //   component: Home,
        // },
        {
          path: '/article/:activeIndex/:id/:articleId',
          name: '详情页',
          key: '1-3',
          component: Article,
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  const value = document.getElementById('first-class-menu') && document.getElementById('first-class-menu').innerText;
  document.title = value ? `南京先河工程技术股份有限公司官方网站 | ${value}` : `南京先河工程技术股份有限公司 | 官方网站`;
  next();
})

export default router;
